import {FC} from 'react'

const RorCell: FC<{
    label: string
    val: number
}> = ({label, val}) => {
    return (
        <>
            <div className="elements-percent flex">
                <div className="row-percent flex">
                    {val !== null ? (
                        <div className=" flex percent">
                            {val?.toLocaleString('pl-PL', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            })}
                        </div>
                    ) : (
                        <div className="ndash flex">&ndash;</div>
                    )}
                    <div className="row-ju">{label}</div>
                </div>
                {val !== null ? (
                    <div className="arrow">
                        <div className={'arrow-parameters ' + (val >= 0 ? 'arrow-up' : 'arrow-down')}></div>
                    </div>
                ) : (
                    <div></div>
                )}
            </div>
        </>
    )
}

export default RorCell
